
import React from "react";
import './Project.css'



const Project = () => { 

    return(

      <>
        

        <div class="container my-5">
          <div class="card-deck">
          <div class="row">
            <div class="col-4 col-md-4">
          <div class="card h-95 mb-4" style={{"width":"18rem"}} >
            <img src={"https://static.independent.co.uk/2023/12/27/12/iStock-527316313-1.jpg?quality=75&width=1200&auto=webp"}
            
             alt="" class="card-img-top"/>
            <div class="card-body">
             <h5 class="card-title">Post-Card-React JS</h5>
            <p class="card-text overflow-auto">
            The application was initially developer using React JS, JavaScript more library
            Clients were able to visualize and  provide  the Postcard using web app in React
            Using apollo client library for JavaScript and data with Graph QL
            </p>
          </div>
          <div class="card-footer">
            <a href="https://postcard.travel/" target="/bank" class="btn btn-primary">Link</a>

          </div>
        </div>
        </div>
        
        <div class="col-4 col-md-4">
        <div class="card h-95 mb-4" style={{"width":"18rem"}} >
            <img src={"https://www.shutterstock.com/image-photo/palms-two-brothers-mountain-on-600nw-318248558.jpg"}
             alt="" class="card-img-top "/>
            <div class="card-body">
             <h5 class="card-title">Post-Card-Next JS</h5>
            <p class="card-text">
            Complete detailed programming and development tasks for front end public and internal websites as well as challenging back-end server code.
            Designed and Developed the official website in basic level using on Next JS


            </p>
          </div>
          <div class="card-footer">
            <a href="https://postcard.travel/" target="/bank" class="btn btn-primary">Link</a>

          </div>
        </div>
        </div>
        
        <div class="col-4 col-md-4">
        <div class="card h-95 mb-4" style={{"width":"18rem"}} >

            <img src={"https://assets-global.website-files.com/634fa4e5766bef420eeb39e1/648c2a92e622896890bd1ec9_648888c231dd1bcbaaa70e6d_59d5f911-4315-4d46-8895-e10d8568dd15_MKT%20(1).jpg"}
             alt=""/>
            <div class="card-body ">
             <h5 class="card-title">QR-Code</h5>
            <p class="card-text">
            JavaScript QR code library for making QR codes. 
            It supports cross-browser with HTML5 Canvas and table tag in DOM. 
            It has .provide an API for generating QR codes with options like size,
            color and Some popular JavaScript QR code generators include QRCode
            
            </p>

          </div>
        
        <div class="card-footer">
          <small>Last Update: college project</small>

          </div>
          </div>
        </div>
        </div>
        </div>
        </div> 
        





</>
    )
}

  

export default Project;



